// src/store/useSearchStore.ts
import { create } from 'zustand';

interface State {
    inputValue: string;    // Lo que el usuario ve en el input
    query: string;         // El término que usamos para filtrar los platos
    setInputValue: (value: string) => void;
    setQuery: (value: string) => void;
    clearSearch: () => void; // Función para el botón "X"
}

export const useSearchStore = create<State>((set) => ({
    inputValue: "",
    query: "",

    // Al escribir, actualizamos el valor visual y el filtro al mismo tiempo
    setInputValue: (value: string) => {
        set({ inputValue: value});
    },

    // Por si necesitas cambiar el filtro manualmente sin tocar el input
    setQuery: (value: string) => {
        set({ query: value });
    },

    // Limpia todo el estado de búsqueda
    clearSearch: () => {
        set({ inputValue: "", query: "" });
    }
}));